import React from 'react';
import { SimpleModal } from '@livable/saas-react-components';
import { observer } from 'mobx-react-lite';
// import useStyles from './styles';
import { useTranslation } from 'react-i18next';
// import { useStore } from 'src/stores';
import { GetForm } from './modalForm';
export const AssignPortfoliosToPropertyModal = observer(_ref => {
  let triggerRefresh = _ref.triggerRefresh,
    currentProperty = _ref.currentProperty,
    externalIsOpen = _ref.externalIsOpen,
    callback = _ref.callback,
    externalPortfolioList = _ref.externalPortfolioList,
    propertyAddress = _ref.propertyAddress;
  // const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  // const store = useStore();

  return /*#__PURE__*/React.createElement(SimpleModal, {
    handleClose: () => callback({
      action: 'cancel'
    }),
    isOpen: externalIsOpen,
    title: t('portfolios_properties_page.assign_portfolio_to_property'),
    subTitle: propertyAddress,
    variant: "staticHeight",
    noFooter: true,
    noPadding: true,
    noLeftButton: true
  }, /*#__PURE__*/React.createElement(GetForm, {
    key: "AssignPortfoliosToPropertyModalForm",
    triggerRefresh: triggerRefresh,
    currentProperty: currentProperty,
    callback: callback,
    externalPortfolioListIds: externalPortfolioList,
    propertyAddress: propertyAddress
  }));
});